import { ExportConfig } from './types'
import { useOnceOffTransactionExportBase } from './useOnceOffTransactionExportBase'

interface UseOnceOffEarnTransactionsExportProps {
  handleClose: () => void
  walletId?: string
}

/**
 * Earn-specific transaction export hook
 * Provides export functionality for Earn asset transactions
 *
 * Features:
 * - Single asset export only (no download all)
 * - Transaction reports only (no balance reports)
 *
 * @param props - Configuration for Earn export
 * @returns Transaction export hook result with all necessary state and handlers
 *
 * @example
 * const exportValues = useOnceOffEarnTransactionsExport({
 *   handleClose: () => setModalOpen(false),
 *   walletId: 'wallet-123'
 * })
 */
export const useOnceOffEarnTransactionsExport = ({
  handleClose,
  walletId,
}: UseOnceOffEarnTransactionsExportProps) => {
  const config: ExportConfig = {
    walletIdResolver: () => ({
      lsid: walletId,
    }),

    buildPayloadExtras: () => ({
      categories: ['EARNING'],
    }),

    amplitudePropsExtras: () => ({
      page: 'earn',
    }),

    features: {
      allowBalanceReport: false, // Earn only supports transaction reports
    },

    errorContext: 'EarnTransactionExport',
  }

  return useOnceOffTransactionExportBase(config, handleClose)
}
